import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Text } from 'foundations-components/components/Text';
import { getCheckedOptionFromView, PRIVATE } from '../../getCheckedOptionFromView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PrivateRadioOption = ({
  viewUpdates,
  setViewUpdates
}) => {
  const isChecked = getCheckedOptionFromView(viewUpdates) === PRIVATE;
  const onRadioChange = useCallback(() => {
    setViewUpdates({
      private: true,
      teamId: undefined
    });
  }, [setViewUpdates]);
  return /*#__PURE__*/_jsxs(RadioInput, {
    checked: isChecked,
    onChange: onRadioChange,
    "data-test-id": `view-sharing-private-checked=${isChecked}`,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.private"
    }), /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      color: "text-core-subtle",
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.privateDescription"
      })
    })]
  });
};